module.exports = __webpack_public_path__ + "img/logo3.b0a64a92.png";